import {PRESENTATION_POSITION_PIP} from '@/store/presentation/options';

export default class PresentationSettings {
    constructor(data) {
        this.position = data.position || PRESENTATION_POSITION_PIP;
    }
}